import {
  FETCH_APPLICATION,
  FETCH_EMPLOYEES,
  FETCH_PLATFORM_SLOTS,
  FETCH_SO_NAMES,
  REASSIGN_APPLICATION,
  REASSIGN_LEAD,
} from '../../resources/endPoint';

export const fetchEmployeeName = data => {
  return {
    url: FETCH_EMPLOYEES,
    payload: data,
    method: 'post',
    tag: 'REASSIGN_PLATFORM',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: 'user-service',
  };
};
export const fetchAssigneeSoName = data => {
  return {
    url: FETCH_SO_NAMES,
    payload: data,
    method: 'post',
    tag: 'FETCH_SO_NAMES',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: '',
  };
};

export const reassignLead = data => {
  return {
    url: REASSIGN_LEAD,
    payload: data,
    method: 'post',
    tag: 'REASSIGN_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: '',
  };
};

export const fetchApplications = data => {
  return {
    url: FETCH_APPLICATION,
    payload: data,
    method: 'post',
    tag: 'FETCH_APPLICATION',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: '',
  };
};
export const fetchPlatformSlotDetails = data => {
  return {
    url: FETCH_PLATFORM_SLOTS,
    payload: data,
    method: 'post',
    tag: 'FETCH_PLATFORM_SLOTS',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: '',
  };
};

export const reassignApplication = data => {
  return {
    url: REASSIGN_APPLICATION,
    payload: data,
    method: 'post',
    tag: 'REASSIGN_LEAD',
    headers: {'content-type': 'application/json'},
    authRequired: true,
    csrfToken: false,
    service: '',
  };
};
